/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Records_Body_NoteInputs */

const en_us2_exercise_sheet_records_body_note = /** @type {(inputs: Exercise_Sheet_Records_Body_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The estimated max strength and the weight tables include your body weight.`)
};

const pt_br2_exercise_sheet_records_body_note = /** @type {(inputs: Exercise_Sheet_Records_Body_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A força máxima estimada e as tabelas de peso incluem o seu peso corporal.`)
};

const es_419_exercise_sheet_records_body_note = /** @type {(inputs: Exercise_Sheet_Records_Body_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fuerza máxima estimada y las tablas de peso incluyen tu peso corporal.`)
};

const pt_pt2_exercise_sheet_records_body_note = /** @type {(inputs: Exercise_Sheet_Records_Body_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A força máxima estimada e as tabelas de peso incluem o teu peso corporal.`)
};

const fr_fr2_exercise_sheet_records_body_note = /** @type {(inputs: Exercise_Sheet_Records_Body_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La force max estimée et les tableaux de charge incluent ton poids de corps.`)
};

const de_de2_exercise_sheet_records_body_note = /** @type {(inputs: Exercise_Sheet_Records_Body_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die geschätzte Maximalkraft und die Gewichtstabellen enthalten dein Körpergewicht.`)
};

const it_it2_exercise_sheet_records_body_note = /** @type {(inputs: Exercise_Sheet_Records_Body_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La forza massima stimata e le tabelle dei pesi includono il tuo peso corporeo.`)
};

/**
* | output |
* | --- |
* | "The estimated max strength and the weight tables include your body weight." |
*
* @param {Exercise_Sheet_Records_Body_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_records_body_note = /** @type {((inputs?: Exercise_Sheet_Records_Body_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Records_Body_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_records_body_note(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_records_body_note(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_records_body_note(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_records_body_note(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_records_body_note(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_records_body_note(inputs)
	return en_us2_exercise_sheet_records_body_note(inputs)
});
export { exercise_sheet_records_body_note as "exercise-sheet.records_body_note" }